import React from 'react';
import { HiOutlineCalendarDays } from 'react-icons/hi2';
import { Table, bookingsColumns } from '../../../commons/Table';
import { useBookings } from '../../../../hooks';
import { Card } from '../../../ui/Card';

const Bookings = () => {
  const { bookings, loading } = useBookings();
  
  return (
    <div className='space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-700'>
      {/* Page Header */}
      <div className='flex flex-col md:flex-row md:items-center justify-between gap-4'>
        <div>
          <h1 className='text-2xl font-bold text-gray-900 dark:text-white'>
            Manage Bookings
          </h1>
          <p className='text-gray-500 dark:text-gray-400 mt-1'>
            View and manage all safari tour reservations.
          </p>
        </div>

      </div>

      {/* Main Content Card */}
      <Card variant='glass' className='border-none shadow-xl shadow-gray-200/50 dark:shadow-none overflow-hidden'>
        {/* @ts-ignore */}
        <Table 
          columns={bookingsColumns} 
          data={bookings} 
          loading={loading} 
          hideActions 
          recordName='Bookings'
          placeholder='Search results...'
        />
      </Card>
      
      {/* Footer Info */}
      <div className='flex items-center gap-2 text-xs text-gray-400 dark:text-gray-500 px-2'>
        <HiOutlineCalendarDays className='w-3.5 h-3.5' />
        Last updated: {new Date().toLocaleTimeString()}
      </div>
    </div>
  );
};

export default Bookings;
